export default __webpack_public_path__ + "static/media/productImageNotAvailable.2af11963.png";